<template>
  <!-- 配置 -->
  <div class="content-item-main">
    <div class="content-item-list" style="width:100%;">
      <div class="content-item-btn">
        <a-button
          type="green"
          size="small"
          @click="update()"
          icon="plus"
          v-auth="['auth_deviceModel_config_add']"
        >
          {{ $t('com_btn_add') }}
        </a-button>

        <a-button
          type="red"
          size="small"
          @click="deleteBatch()"
          v-if="list && list.length"
          icon="delete"
          v-auth="['auth_deviceModel_config_delete_batch']"
          :disabled="!selectedRowKeys.length"
        >
          {{ $t('com_btn_delete') }}
        </a-button>

        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          :placeholder="$t('deviceModel_table_filter_group')"
          size="small"
          show-search
          allowClear
          @change="filterByGroup"
          style="min-width:150px;"
          v-if="groupList && groupList.length"
          :filter-option="
            (input, option) => {
              return (
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            }
          "
        >
          <a-select-option :value="group.groupId" v-for="group in groupList" :key="group.groupId">
            {{ group.groupName }}
          </a-select-option>
        </a-select>
      </div>
      <div class="g-table">
        <a-table
          :columns="columns"
          :data-source="listCurrent"
          :pagination="false"
          :rowKey="(_text, index) => _text.id"
          bordered
          :row-selection="
            authList.includes('auth_deviceModel_config_delete_batch') || isSuperAdmin
              ? rowSelection
              : null
          "
          :scroll="{ x: true }"
          :loading="tableLoading"
          size="small"
        >
          <!-- 名称 -->
          <template slot="name" slot-scope="text, record">
            <div
              @click="update(record)"
              style="text-decoration: underline;cursor: pointer;"
              v-if="authList.includes('auth_deviceModel_config_edit') || isSuperAdmin"
            >
              {{ text }}
            </div>
            <div v-else>
              {{ text }}
            </div>
          </template>

          <template slot="DataRange" slot-scope="text, record">
            <!-- 枚举型 -->
            <div v-if="record.dataType === 4">
              <p v-for="item in text.split('\n')" :key="item" style="margin:0;">
                {{ item }}
              </p>
            </div>
            <span v-else>{{ text }}</span>
          </template>

          <!-- Edit -->
          <template slot="Input" slot-scope="text">
            {{ text ? $t('com_table_yes') : $t('com_table_no') }}
          </template>

          <!-- 操作 -->
          <template slot="Action" slot-scope="text, record">
            <!-- 父级的，不允许编辑 -->
            <!-- 父级只能获取到父级的配置/参数，子集可获取到父级和子集自己的配置和参数 -->
            <a-button
              type="primary"
              size="small"
              @click="update(record)"
              v-auth="['auth_deviceModel_config_edit']"
              style="margin-right:15px"
              v-if="(currentModel.parentId && !record.parent) || !currentModel.parentId"
            >
              {{ $t('com_btn_edit') }}
            </a-button>

            <a-button
              type="special"
              size="small"
              @click="update(record, true)"
              icon="fork"
              v-auth="['auth_deviceModel_config_add']"
              style="margin-right:15px"
            >
              {{ $t('com_btn_fork') }}
            </a-button>

            <a-button
              type="danger"
              size="small"
              @click="deleteBatch(record.id)"
              v-auth="['auth_deviceModel_config_delete_batch']"
              v-if="(currentModel.parentId && !record.parent) || !currentModel.parentId"
            >
              {{ $t('com_btn_delete') }}
            </a-button>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/system/model';
import { mapGetters } from 'vuex';

export default {
  props: {
    allGroup: {
      type: [Array, Object],
      default: () => [],
    },
    currentModel: {
      type: Object,
      default: () => {},
    },
    updateFn: {
      type: Function,
      default: () => {},
    },
    scrollEvent: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      groupList: [],
      currentGroup: null,

      selectedRowKeys: [],
      // 配置表头
      tableLoading: false,
      list: [],
      listCurrent: [],
      columns: [
        {
          title: '#',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
        },
        {
          title: this.$t('com_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },

        {
          title: this.$t('deviceModel_table_group_name'),
          dataIndex: 'groupName',
        },

        {
          title: this.$t('deviceModel_form_protocol'),
          dataIndex: 'dataSrc',
        },

        {
          title: this.$t('deviceModel_form_data_read_level'),
          dataIndex: 'rlevel',
        },

        {
          title: this.$t('deviceModel_form_input') + '？',
          dataIndex: 'input',
          scopedSlots: { customRender: 'Input' },
        },

        {
          title: this.$t('configModel_form_item_data_range'),
          dataIndex: 'dataRange',
          scopedSlots: { customRender: 'DataRange' },
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
    rowSelection() {
      return {
        onChange: (selectedRowKeys, _selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
        },
        getCheckboxProps: record => ({
          props: {
            // 非父级才支持多选
            disabled: record.parent,
            name: record.name,
          },
        }),
      };
    },
  },

  created() {
    // 操作
    if (
      this.authList.includes('auth_deviceModel_config_edit') ||
      this.authList.includes('auth_deviceModel_config_delete_batch') ||
      this.isSuperAdmin
    ) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        width: 220,
        scopedSlots: { customRender: 'Action' },
      });
    }
    this.getList();
  },

  methods: {
    // 获取当前Model 配置列表
    getList() {
      this.tableLoading = true;
      API.DeviceConfigList({ devModelId: this.currentModel.devModelId })
        .then(res => {
          if (res.code === 0) {
            this.list = res.data || [];
            this.filterByGroup(this.currentGroup);

            // 计算当前配置的分类
            const _configGroup = [];
            const groupIds = Array.from(new Set(this.list.map(item => item.groupId)));
            if (this.allGroup && this.allGroup.length) {
              this.allGroup.forEach(item => {
                if (groupIds.includes(item.groupId)) {
                  _configGroup.push(item);
                }
              });
            }
            this.groupList = _configGroup;
          }
        })
        .finally(() => {
          this.tableLoading = false;
          this.scrollEvent();
        });
    },

    // batch delete config item
    deleteBatch(id) {
      let ids = [];
      if (typeof id !== 'undefined') {
        ids.push(id);
      } else {
        ids = this.selectedRowKeys;

        if (!(ids && ids.length)) {
          this.$message.error(this.$t('com_msg_select_item_first'));
          return;
        }
      }

      const h = this.$createElement;
      this.$confirm({
        title:
          ids.length > 1
            ? this.$t('deviceModel_confirm_delete_some_item_title')
            : this.$t('deviceModel_confirm_delete_item_title'),
        content: h('div', {}, [h('p', `Item IDs: ${ids}`)]),
        centered: true,
        onOk: () => {
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.DeviceConfigDeleteBatch({ cfgIds: ids.join(',') })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getList();
                this.selectedRowKeys = [];
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 添加/编辑config item
    update(record, fork) {
      this.updateFn('config', record, fork);
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    filterByGroup(group) {
      console.log('group', group);
      this.currentGroup =
        typeof group === 'number' ? this.groupList.find(item => item.groupId === group) : group;

      if (!group) {
        this.listCurrent = this.list;
      } else {
        this.listCurrent = this.list.filter(item => item.groupId === this.currentGroup.groupId);
      }
    },
  },
};
</script>
